import React, { useRef, useState } from "react";
import Slider from "react-slick";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const Retail = () => {
  const { t } = useTranslation();
  const sliderRef2 = useRef(null);

  const [lightbox, setLightbox] = useState({
    open: false,
    slides: [],
    index: 0,
  });

  const openLightbox = (slides, index) => {
    setLightbox({
      open: true,
      slides,
      index,
    });
  };

  const sliderSettings2 = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    centerMode: true,
    centerPadding: "0px",
    arrows: false, // We are using custom arrows
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const sliderContent = [
    <div className="image-card" key={0}>
      <img src="/images/new_45.jpg" alt="" />
    </div>,
    <div className="image-card" key={1}>
      <img src="/images/new_46.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/E2.jpg" alt="" />
    </div>,
    <div className="image-card" key={3}>
      <img src="/images/E3.jpg" alt="" />
    </div>,
  ];

  const slides = sliderContent.map((card) => ({
    src: card.props.children.props.src,
  }));

  return (
    <Container>
      <Row className="section border">
        <Col md={5} className="d-flex flex-column justify-content-center">
          <h2>{t("retail_main_title")}</h2>
          <p>{t("retail_main_p")}</p>
        </Col>
        <Col md={7}>
          <Row>
            <div className="sigle-slider ">
              <Slider ref={sliderRef2} {...sliderSettings2}>
                {sliderContent.map((card, idx) =>
                  React.cloneElement(card, {
                    onClick: () => openLightbox(slides, idx),
                  })
                )}
              </Slider>
              <div className="slider-arrows">
                <button
                  className="slick-prev-custom"
                  onClick={() => sliderRef2.current.slickPrev()}
                >
                  <FaArrowLeft />
                </button>
                <button
                  className="slick-next-custom"
                  onClick={() => sliderRef2.current.slickNext()}
                >
                  <FaArrowRight />
                </button>
              </div>
            </div>
          </Row>
        </Col>
      </Row>
      <Lightbox
        open={lightbox.open}
        close={() => setLightbox({ ...lightbox, open: false })}
        slides={lightbox.slides}
        index={lightbox.index}
      />
    </Container>
  );
};

export default Retail;
